const PAGE_SIZE = 24;

export { PAGE_SIZE };
